<template>
  <div :class="{'expanded': supportExpandOnResize}">
    <div
      v-if="frameUrl"
      class="frame-wrapper frame-full-screen"
      :style="{backgroundColor: frameBg}"
    >
      <div class="frame-close-btn">
        <v-btn
          icon
          @click="closeFrame"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <iframe
        class="frame"
        :src="frameUrl"
      ></iframe>
    </div>
    <div
        v-if="$vuetify.breakpoint.mobile"
        class="bg-head"
    ></div>

    <v-app :class="{mobile: $vuetify.breakpoint.mobile}">
      <Header :show-menu="showMenu"></Header>

      <v-main>
        <div
            v-if="!resolved || !contextResolved"
            class="text-center my-5"
        >
          <v-progress-circular
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>

        <v-container
            v-if="showMainContent"
            fluid
            :class="{'px-0': $vuetify.breakpoint.mobile}">

          <AllowPermissions v-if="needPermissions"></AllowPermissions>

          <AllowToken v-if="allowToken"></AllowToken>

          <AllowMessages v-if="allowMessages"></AllowMessages>

          <AllowSubscription v-if="allowSubscription"></AllowSubscription>

          <Downtime 
            v-if="this.isDownTimeActive"
            :dataDown="dataSettings"
            @close="closeDownPage"
          ></Downtime>

          <router-view v-if="resolved && showApp"></router-view>

        </v-container>

        <section v-else-if="!user.loading">
          <Landing
              v-if="user.unauthorized"
          ></Landing>
          <Landing
              v-else
              can-skip
              @skip="skipIntro"
          ></Landing>
        </section>
<!--        <div v-if="user.data.admin || user.data.moder">-->
<!--            <script src="//cdn.jsdelivr.net/npm/eruda"></script>-->
<!--            <script>eruda.init({-->
<!--              defaults: {-->
<!--                displaySize: 50,-->
<!--                transparency: 0.9,-->
<!--                theme: 'Monokai Pro'-->
<!--              }-->
<!--            });</script>-->
<!--        </div>-->
        <Footer></Footer>
        <Snackbar></Snackbar>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import AllowPermissions from '@/components/AllowPermissions'
import AllowToken from '@/components/AllowToken'
import AllowMessages from '@/components/AllowMessages'
import AllowSubscription from '@/components/AllowSubscription'
import Downtime from '@/components/Downtime'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Landing from '@/components/Landing'
import Snackbar from '@/components/Snackbar'
import {
  getIsVkAppDesktop,
  getIsVkAppMobile,
  getMessagesDisabled,
  getMessagesRejected,
  getResolved,
  getSourceIsDemo,
  getTokenRejected,
  setSource
} from '@/composables/context'
import {getUrl} from '@/composables/frame'
import {getUser, setUserShowIntro} from '@/composables/user'
import {isSharedState} from '@/constants'
import {resizeWindow} from '@/services/vkApi'
import {getSettingsDown} from '@/services/maintenance'
import Statuses from '@/services/statuses'

const maxHeight = 700
const maxWidth = 1000
const resizeObserver = window.ResizeObserver && new window.ResizeObserver(entries => {
  resizeWindow(maxWidth, Math.max(entries[0].contentRect.height, maxHeight))
})

export default {
  name: 'App',
  components: {Landing, AllowSubscription, AllowMessages, AllowToken, AllowPermissions, Snackbar, Footer, Header, Downtime},
  computed: {
    frameUrl () {
      return getUrl()
    },
    isDemo () {
      return this.user.context && getSourceIsDemo()
    },
    isVkAppMobile: getIsVkAppMobile,
    allowToken () {
      return !this.isDemo && this.contextResolved && getTokenRejected()
    },
    allowMessages () {
      return !this.isDemo && this.contextResolved && getMessagesDisabled()
    },
    allowSubscription () {
      return !this.isDemo && this.contextResolved && getMessagesRejected()
    },
    downtime () {
      return !this.isDemo && this.contextResolved && this.isDownTimeActive
    },
    contextResolved: getResolved,
    currentState () {
      return this.$route.name
    },
    needPermissions () {
      return this.user.data.message &&
          (!this.user.data.message.permissions.buyoutPayment || !this.user.data.message.permissions.buyoutDelivery)
    },
    resolved () {
      return !this.user.loading
    },
    showApp () {
      return this.contextResolved && !this.allowToken && !this.allowMessages && !this.allowSubscription && !this.downtime
    },
    showMenus () {
      return this.user.authorized && !this.user.data.showIntro
    },
    showMainContent () {
      return this.showMenus || isSharedState(this.currentState)
    },
    showMenu () {
      return this.contextResolved && this.showMenus && !this.allowToken && !this.allowMessages && !this.allowSubscription && !this.downtime
    },
    supportExpandOnResize: getIsVkAppDesktop,
    user: getUser
  },
  data () {
    return {
      frameBg: '',
      isDownTimeActive: false,
      isCheckDown: true
    }
  },
  methods: {
    closeFrame () {
      window.postMessage({
        'msg': {
          type: 'close',
          result: 'hide'
        }
      }, '*')
    },
    closeDownPage () {
      this.isDownTimeActive = false
      this.isCheckDown = false
    },
    skipIntro () {
      setUserShowIntro(false)
    },
    pingDownPage () {
      getSettingsDown().then(data => {
        this.dataSettings = data
        if(this.isDownTimeActive && data?.downTo < Date.now()) {
          window.location.reload()
          return
        }
        if(!this.isDownTimeActive && data?.downTo > Date.now()) {
          this.isDownTimeActive = true
        }
      })
    }
  },
  mounted () {
    this.pingDownPage(),
    Statuses.askStatuses(),
    setInterval(() => {
      if(this.isCheckDown) this.pingDownPage()
    }, 30000)
  },
  watch: {
    $route: {
      handler: function (to) {
        setSource(to.params.sourceId, to.query.adminLevel)
      },
      immediate: true
    },
    frameUrl (val) {
      if (val) {
        setTimeout(() => this.frameBg = 'white', 5000)
      } else {
        this.frameBg = ''
      }
    },
    supportExpandOnResize: {
      handler: function (val) {
        if (val && resizeObserver) {
          resizeObserver.observe(document.body)
        } else if (resizeObserver) {
          resizeObserver.unobserve(document.body)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/override.scss';
@import '@/styles/mdi.scss';
@import '@/styles/roboto.scss';
.bg-head {
  background-color: #4054B2;
  height: 50px;
  position: absolute;
  top: 0;
  width: 100%;
}
.expanded {
  .v-application--wrap {
    min-height: 100%
  }
}
.frame-wrapper {
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 9999;
  .frame-close-btn {
    position: fixed;
    right: 0;
  }
  .frame {
    border: 0;
    height: 100%;
    margin: 0!important;
    width: 100%;
  }
}
.with-white-spaces {
  .v-list-item__title,
  .v-list-item__subtitle {
    white-space: normal!important;
    margin-bottom: 6px;
  }
}
</style>
